import { DataTable } from '@/components/data-table';
import ContentLayout from '@/components/layout/ContentLayout';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { getQuestionListByTopic, getTopicList } from '@/services/generatedAPIs';
import { QuestionInfo, QuestionLabel } from '@/services/generatedAPIs.schemas';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { ROUTE } from '@/routes/constants';
import { isEN } from '@/utils/i18n';
import { QuestionOrigin } from '@/utils/constants';

type TableData = {
  topic: QuestionLabel
  questions: QuestionInfo[]
  name: string
}

const LibraryPage = () => {
  const { t, i18n } = useTranslation();
  const { getCurrentUser } = useAuth();
  const [tableData, setTableData] = useState<TableData[]>([]);


  const columns: ColumnDef<TableData>[] = [
    {
      id: "select",
      header: ({ table }) => (
        //   <Checkbox
        //     checked={
        //       table.getIsAllPageRowsSelected() ||
        //       (table.getIsSomePageRowsSelected() && "indeterminate")
        //     }
        //     onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        //     aria-label="Select all"
        //   />
        <></>
      ),
      cell: ({ row }) => (
        //   <Checkbox
        //     checked={row.getIsSelected()}
        //     onCheckedChange={(value) => row.toggleSelected(!!value)}
        //     aria-label="Select row"
        //   />
        <></>
      ),
      enableSorting: true,
      enableHiding: false,
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            {t("teacher.unitname")}
            <ArrowUpDown />
          </Button>
        )
      },
      cell: ({ row }) => (
        <div>{isEN(i18n) ? row.original.topic.enName : row.original.topic.name}</div>
      ),
    },
    {
      accessorKey: "qcount",
      header: () => { return (<span>{t("teacher.qcount")}</span>) },
      cell: ({ row }) => <div>{row.original.questions.length}</div>,
    },
    {
      id: "actions",
      enableHiding: false,
      cell: ({ row }) => {
        const info = row.original;

        return (
          <div className='flex place-content-evenly'>
            <NavLink to={ROUTE.TEACHER.LIBRARY_TOPIC_EDIT} state={{ topicId: info.topic.id, questions: info.questions, topicName: isEN(i18n) ? info.topic.enName : info.topic.name }}><Button variant="outline">{t("teacher.editquestion")}</Button></NavLink>
          </div>
        )
      },
    },
  ]

  useEffect(() => {
    if (tableData.length > 0) {
      return;
    }

    async function update() {
      try {
        const topicRsp = await getTopicList({
          teacherId: getCurrentUser()!.id,
          schoolName: getCurrentUser()!.schoolName
        });

        if (topicRsp.code !== 200 || !topicRsp.data) {
          console.log('getTopicList error', topicRsp)
          return;
        }

        const topicInfos = topicRsp.data.topicInfos;
        const questionInfoRsp = await getQuestionListByTopic({
          topicIds: topicInfos.map((topicInfo) => topicInfo.id!),
          libraryNames: QuestionOrigin.map(value => value.originName),
          includePress: true,
        });

        if (questionInfoRsp.code !== 200 || !questionInfoRsp.data) {
          console.log('getQuestionListByTopic error', questionInfoRsp)
          return;
        }

        const tableData = new Array<TableData>();
        topicInfos.forEach((topic: QuestionLabel, index: number) => {
          tableData[index] = {
            topic: topic,
            questions: questionInfoRsp.data!.questionList[index],
            name: isEN(i18n) ? topic.enName! : topic.name!
          };
        });
        setTableData(tableData);
      } catch (error) {
        console.log('update error', error)
      }
    }
    update();
  });

  return (
    <ContentLayout title={t("teacher.library")}>
      <div className='p-4 bg-muted m-2 rounded-2xl'>
        <DataTable data={tableData} columns={columns} filterColumn='name' filterName={t('teacher.unitname')} />
      </div>
    </ContentLayout>
  );
};

export default LibraryPage;